<style lang="less">
</style>
<template>
    <span>
        <Drawer title="选项列表" :closable="false" placement="right" v-model="transfercourse" width="60%">
            <Row class="operation">
                <Button @click="add" type="primary" icon="md-add">新增</Button>
                <circleLoading v-if="operationLoading"/>
            </Row>
            <Row style="padding-top: 5px">
                <Table :loading="loading" border :columns="columns" :data="data" ref="userTable"></Table>
            </Row>
            <Row type="flex" justify="end" class="page">
                <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
            </Row>
        </Drawer>
        <answer-drawer ref="answerDrawer"></answer-drawer>
    </span>
</template>

<script>
    import {examOptList,delExamOpt} from "@/api/bus";
    import answerDrawer from "./answer-drawer";
    export default {
        name: "answer-manage",
        components: {
            answerDrawer
        },
        data() {
            return {
                loading: false, // 表单加载状态
                operationLoading: false,
                transfercourse: false,
                drop: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                searchForm: {
                    pageNumber: 1, // 当前页数
                    pageSize: 50, // 页面大小
                    sort: "examOptionCode", // 默认排序字段
                    order: "asc", // 默认排序方式
                    examId: '',
                },
                selectDate: null, //选择日期绑定modal
                columns: [
                    {
                        type: "index",
                        width: 50,
                        align: "center"
                    },
                    {
                        title: "选项内容",
                        align: "center",
                        ellipsis:true,
                        tooltip:true,
                        key: "examOptionName",
                    },
                    {
                        title: "选项编码",
                        align: "center",
                        key: "examOptionCode"
                    },
                    {
                        title: "是否正确",
                        align: "center",
                        key: "correct",
                        render: (h, params) => {
                            if (params.row.correct === 0) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "red"
                                            }
                                        },
                                        "否"
                                    )
                                ]);
                            } else {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "blue"
                                            }
                                        },
                                        "是"
                                    )
                                ]);
                            }
                        }
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row);
                                            }
                                        }
                                    },
                                    "编辑"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small"
                                        },
                                        on: {
                                            click: () => {
                                                this.remove(params.row);
                                            }
                                        }
                                    },
                                    "删除"
                                )
                            ]);
                        }
                    }],
                data: [], // 表单数据
                total: 0 // 表单数据总数
            }
        },
        methods: {
            showDrawer(params){
                this.transfercourse = true;
                if (params.id) {
                    this.searchForm.examId = params.id;
                    this.getDataList();
                }
            },
            getDataList() {
                this.loading = true;
                examOptList(this.searchForm).then(res => {
                    console.info(res)
                    this.loading = false;
                    this.data = res.data.rows;
                    this.total = res.data.total;
                });
            },
            remove(v) {
                this.$Modal.confirm({
                    title: "确认删除",
                    content: "您确认要删除该选项吗?",
                    onOk: () => {
                        delExamOpt(v.id).then(res => {
                            if (res.status === true) {
                                this.$Message.success("删除成功");
                                this.getDataList();
                                this.$parent.getDataList();
                            }
                        });
                    }
                });
            },
            add() {
                let query = {examId: this.searchForm.examId};
                this.$refs.answerDrawer.showDrawer(query);
            },
            edit(v) {
                this.$refs.answerDrawer.showDrawer(v);
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
        },
        mounted() {
        }
    }
</script>
